define('SageDotCom/DataLayer/Events/Forms/formStepCompleteError',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function FormStepCompleteErrorEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'form_step_N_complete_error'; // overwrite name
    }

    FormStepCompleteErrorEvent.prototype = Object.create(EventBase.prototype);

    FormStepCompleteErrorEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, buttonScope) {

        var form;
        var progressBar;
        var stepNo = 1;

        if (scope) {
            form = $(scope).closest('form');

            if (form.find(".product-trial-form").length > 0) {
                progressBar = $(".product-trial-header .progress-bar-holder");
            }
            else if (form.find(".privacy-rights-request-form").length > 0) {
                progressBar = $(".score-style-box.privacy-rights-request .progress-bar-holder");
            }
            else {
                progressBar = form.siblings(".progress-bar-holder");
            }

            stepNo = progressBar.length > 0 ? parseInt(progressBar.find("li .progress-bar-current .progress-bar-index")[0].textContent) : 1;
        }

        var eventDataGA4 = {
            "event": this.getName().replace("N", stepNo), //event name
            "triggered_by": "sitecore",
            "release_date": "20th February 2025"
        }
        if (scope) {
            var level5 = form.find('[data-sc-field-name="Level5"]');
            var modal = $(scope).closest(".modal");

            var formElems = form.find(".current-section .form-control, .current-section .control-checkbox");
            var allElems = "";

            var errorElem = form.find(".current-section .input-validation-error");
            var elementsWithError = "";

            var spans = form.find(".current-section .field-validation-error span");
            var errorMessage = "";
           
            if (formElems.length > 0) {
                var comma = "";
                $(formElems).each(function (index) {
                    if (index > 0) {
                        comma = ", ";
                    }
                    var currentFormElement = $(this);
                    allElems = allElems + comma + currentFormElement.attr("data-sc-field-name");
                });
            }

            if (errorElem.length > 0 && spans.length > 0) {
                var comma = "";
                $(errorElem).each(function (index) {
                    if (index > 0) {
                        comma = ", ";
                    }
                    var fieldNameInError = errorElem[index].getAttribute("data-sc-field-name");
                    if (elementsWithError.indexOf(fieldNameInError) < 0) {
                        elementsWithError = elementsWithError + comma + fieldNameInError;
                    }
                    var textContent = "";
                    if (spans && index < spans.length) {
                        textContent = spans[index].textContent;
                        errorMessage = errorMessage + comma + textContent;
                    }
                });
            }
            else {
                // no errors on form current step so do not send this event
                return null;
            }

            eventDataGA4 = $.extend(eventDataGA4, {
                "gate_content_name": level5.length > 0 ? level5[0].defaultValue : "(not set)",
                "form_step": stepNo,
                "total_steps": progressBar.length > 0 ? progressBar.find("li").length : 1,
                "form_type": progressBar.length > 0 ? "multistep" : "normal",
                "form_id": form.attr('id'),
                "display_method": modal.length > 0 ? "modal" : "inline",
                "form_elements": allElems,
                "form_elements_with_error": elementsWithError,
                "error_code": "",
                "error_message": errorMessage,
                "element_text": buttonScope.text(),
                "element_id": buttonScope.attr("id") !== undefined ? buttonScope.attr("id") : "(not set)",
                "element_class": buttonScope.attr("class")
            });
        }
        return eventDataGA4;
    }

    return new FormStepCompleteErrorEvent();
});
